import { safeDataLayerPush } from './safeDataLayerPush';

export const handleTrackingEventName = ({
  trackingEventName,
  href,
  additionalData = {}
}: {
  trackingEventName: any;
  href: any;
  additionalData?: Record<string, any>;
}) => {
  if (trackingEventName) {
    safeDataLayerPush({
      event: trackingEventName,
      isCustomEvent: 1,
      url: href,
      ...additionalData
    });
  }
  return true;
};
